import React from 'react';
import { Box } from '@mui/material';
import { LayoutItem } from 'react-grid-layout';
import { ReactComponent as GatewayErrorIcon } from '../../../../../../../../assets/dashboard/GatewayError.svg';
import {
  ILabelValuePanel,
  IGatewayErrorPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import LabelValuePanel from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import useAirConnectStatus from '../../../../../../../../service/device/CommanderAPI/hooks/useAirConnectStatus';
import { useTranslation } from 'react-i18next';

export interface GatewayErrorPanelProps {
  panel: IGatewayErrorPanel;
  layout?: LayoutItem | undefined;
}

function GatewayErrorPanel(props: GatewayErrorPanelProps) {
  const { panel, layout } = props;
  const { t } = useTranslation();
  const { isFetching, currentData, error } = useAirConnectStatus(panel);

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `gateway_error`,
    title: panel.title,
    icon: <GatewayErrorIcon height={'100%'} />,
    content: (
      <Box
        width="100%"
        height={'100%'}
        minWidth={120}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        {currentData?.gatewayLost ?? 0}
      </Box>
    ),
    loading: isFetching,
    error: error ? t('dashboard.error.fetching') : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default GatewayErrorPanel;
